<template>
  <div class="user-address">
    <div class="title">
      <span>本地址将提供给 <em>{{platform.brand}}</em></span>
      <div class="edit-address" v-show="showEdit">
        <button class="edit" @click="$emit('edit')">修改地址</button>
      </div>
    </div>
    <div class="address-details">
      <p class="address-tit">收货地址</p>
      <p class="address-intro">{{userAddressDetails(address)}}</p>
      <p class="user-info">
        <span class="name">{{address.name}}</span>
        <span class="phone">{{address.mobile}}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userAddressChange',
  props: {
    showEdit: {
      type: Boolean
    },
    platform: {
      type: Object
    },
    address: {
      type: Object
    }
  },
  computed: {
    userAddressDetails (address) {
      return (address) => {
        if (address) {
          const townName = address.town_name !== '0' ? address.town_name : ''
          return address.province_name + address.city_name + address.district_name + townName + address.address_detail
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.user-address {
  color: @base;
  background-color: #FFFAE5;
  // border-radius: 0.12rem;
  border: 0.5px solid #E6D074;
  box-sizing: border-box;
  .title {
    height: 0.66rem;
    border-bottom: 0.5px solid #E6D074;
    box-sizing: border-box;
    .flex-between;
    padding: 0 0.2rem;
    font-size: @fz24;
    .edit-address {
      color: #0076FF;
    }
  }
  .address-details {
    padding: 0.24rem 0.2rem;
    font-size: @fz26;
    .address-tit {
      color: @c80;
    }
    .address-intro {
      padding: 0.1rem 0;
    }
    .user-info {
      color: @c80;
    }
  }
}
</style>
